import {
  swalError,
  swalSuccessNoButton,
  swalSuccessWithButton,
  getCookie
} from "./core";
import Swal from "sweetalert2";
import Backend from "i18next-http-backend";
import i18next from "i18next";
import storeLocale from "./i18n/bonus.json";

let userEmail = '';
const baseWaitingTime = 30;
let retryCount = 1;
const maxRetryCount = 3;

const WAIT_RESEND_PHONE_TOKEN = 30; // 6 minutes, time in seconds to wait before retrying generate a new token
const WAIT_GENERATE_PHONE_TOKEN = 30; // 6 minutes, time in seconds to wait before retrying generate a new token

class ModalRegister {

  // "advertising_code": {
  //   "id": 6483,
  //   "code": "95418ce4-695f-448b-9adc-87db21491dd4",
  //   "data": "{\"adv\":\"PIXEL\",\"code\":\"95418ce4-695f-448b-9adc-87db21491dd4\"}",
  //   "advertising_company_id": 3,
  //   "created_at": "2025-09-24T02:44:48.000000Z",
  //   "updated_at": "2025-09-24T02:44:48.000000Z",
  //   "advertising_company": {
  //     "id": 3,
  //     "name": "PIXEL",
  //     "description": null,
  //     "adv": "PIXEL",
  //     "website": null,
  //     "phone": null,
  //     "address": null,
  //     "created_at": "2025-09-19T00:58:14.000000Z",
  //     "updated_at": "2025-09-19T00:58:15.000000Z",
  //     "whitelabel_id": 130
  //   }
  // }
  static triggerEvent(advertising_code) {
    let message = 'registroExitoso';
    if (advertising_code) {
      message += `-${advertising_code?.advertising_company?.adv}-${advertising_code?.code}`;
    }

    console.log('Triggering event to Google Tag Manager with message: ', message);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: message
    });
  }

  formRegister() {
    let $button = $('#button-register-user');
    let $form = $('#register-form');

    $button.click(() => {
      ModalRegister.register($button, $form);
    });

    $form.keypress(function (event) {
      if (event.keyCode === 13) {
        $button.click();
      }
    });

    $(function () {
      $('[data-toggle="tooltip"]').tooltip();

      $(document).on('input', '.form-templates-v6 .animation-label', function () {
        if ($(this).val() && $(this).val().length > 0) {
          $(this).addClass('active')
        } else {
          $(this).removeClass('active')
        }
      })

      $.each($('.form-templates-v6 .animation-label'), function (inputIndex, inputValue) {
        if ($(this).val() && ($(this).val()).length > 0) {
          $(this).addClass('active')
        } else {
          $(this).removeClass('active')
        }
      })

    })
  }

  modalRegisterClose() {
    let locale = getCookie('language-js');
    locale = (locale === null || locale === '') ? 'en_US' : locale;

    i18next.use(Backend)
      .init({
        lng: locale,
        resources: storeLocale
      });

    $('#close-register-modal').on('click', function () {
      const button = $(this);
      Swal.fire({
        title: button.data('title'),
        html: button.data('description'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ff7600',
        cancelButtonColor: '#999',
        confirmButtonText: i18next.t('Ok'),
        cancelButtonText: i18next.t('Cancel')
      }).then((result) => {
        if (result.value) {
          $('#register-modal').modal('hide');
          sessionStorage.setItem('modalRegister', 'shown');
        }
      });
    });
  }

  needHelp() {
    $('#help-register-modal').on('click', function () {
      toggleChatWindow();
      $('#register-modal').modal('hide');
      sessionStorage.removeItem('modalRegister');
    });
  }

  // Checkbox Register Disabled
  checkboxRegister() {
    $("#myWizard input[type='checkBox']").change(function () {
      var len = $("#myWizard input[type='checkBox']:checked").length;
      if (len == 0)
        $("button#button-register-user").prop("disabled", true);
      else
        $("button#button-register-user").removeAttr("disabled");
    });
    $("#myWizard input[type='checkBox']").trigger('change');
  }

  resendActivationEmail() {
    $('#resend-activation-email').on('click', function (e) {
      e.preventDefault();
      const $button = $(this);
      $button.button('loading');
      $.ajax({
        url: $button.data('action'),
        method: 'post',
        dataType: 'json',
        data: {
          email: userEmail
        }
      }).done(json => {
        swalSuccessWithButton(json);
      }).fail(function (json) {
        swalError(json);
      }).always(function () {
        ModalRegister.resetButton($button);
      });
    });
  }

  // create a timeout function to reset the button with a countdown inside the button that increases the wiating time
  static resetButton($button) {
    let time = baseWaitingTime * retryCount;
    const innerText = $button.html();
    $button.prop('disabled', true);
    if (retryCount >= maxRetryCount) {
      $button.html(innerText);
      return;
    }
    const interval = setInterval(() => {
      if (time > 0) {
        $button.html(`Wait (${time})`);
        time--;
      } else {
        clearInterval(interval);
        $button.button('reset');
        $button.html(innerText);
        retryCount++;
      }
    }, 1000);
  }

  static async register($button, $form) {
    const $cloneButton = $button.clone();
    $cloneButton.removeAttr('id');
    $cloneButton.removeAttr('data-loading-text');
    $cloneButton.prop('disabled', true);
    $button.button('loading');
    userEmail = $form.find('input[name="email"]').val()
    $.ajax({
      url: $form.attr('action'),
      method: 'post',
      dataType: 'json',
      data: $form.serialize()
    }).done(json => {
      // trigger event
      ModalRegister.triggerEvent(json.data.advertising_code);
      $form.trigger('reset');
      if (json.data.route === undefined) {
        $('#register-form .stabilizer-content').addClass('d-none');
        $('#myWizard').easyWizard('goToStep', 2);
        $('#modal-register-footer').html($cloneButton);
      } else {
        swalSuccessNoButton(json);
        setTimeout(() => window.location.href = json.data.route, 1000);
      }
    }).fail(function (json) {
      swalError(json);
    }).always(function () {
      $button.button('reset');
      $button.prop('disabled', true);
    });
  }

  static waitOnButton($button, waitingTime) {
    let time = waitingTime;
    const innerText = $button.html();
    $button.prop('disabled', true);
    // if (retryCount >= maxRetryCount) {
    //   $button.html(innerText);
    //   return;
    // }
    const interval = setInterval(() => {
      if (time > 0) {
        $button.html(`Wait (${time})`);
        time--;
      } else {
        clearInterval(interval);
        // $button.button('reset');
        $button.removeAttr('disabled');
        $button.html(innerText);
        // retryCount++;
      }
    }, 1000);
  }

  static sendSmsToken() {
    const $button = $('#generate-sms-token');
    if (!$button.length) {
      return;
    }

    // Prevent multiple clicks
    if ($button.prop('disabled') || $button.hasClass('loading')) {
      return;
    }

    const actionUrl = $button.data('action');
    if (!actionUrl || !String(actionUrl).trim()) {
      return;
    }

    ModalRegister.waitOnButton($button, WAIT_GENERATE_PHONE_TOKEN);

    $.ajax({
      url: actionUrl,
      method: 'POST',
      dataType: 'json',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: {
        code: $('#calling_code_recheck').val(),
        phone: $('#input_phone_recheck').val(),
        token: $('#input-sms-token').val()
      },
    }).done(json => {
      swalSuccessNoButton(json);
    }).fail(function (xhr, status, error) {
      swalError(xhr);
    }).always(function () {
      console.log('SMS token request completed');
    });
  }
}

$(function () {
  $('#myWizard').easyWizard({
    stepsContainer: '#stepsContainer',
    'stepsText': '{n}',
    showButtons: false,
    'stepTitleContainer': '#stepTitleContainer',
  });
  const modalRegister = new ModalRegister();
  modalRegister.formRegister();
  modalRegister.modalRegisterClose();
  modalRegister.checkboxRegister();
  modalRegister.resendActivationEmail();
  modalRegister.needHelp();

  if (registerByModal) {
    $('#register-modal').modal('show');
  }


  // if the modal was not shown in the actual session, show it
  if (sessionStorage.getItem('modalRegister') !== 'shown') {
    // userData is defined in resources/views/layout/headers/header-6.blade.php
    // should show the modal if userData is not null
    // should show the step 2 if the userData.phone_token is null
    if (userData !== null) {
      if (userData.phone_token === null) {
        $('#register-modal').modal('show');
        $('#myWizard').easyWizard('goToStep', 2);
        $('#myWizard').easyWizard('resizeSteps');
        $('#button-finish-step').addClass('d-none');

        if ($('#generate-sms-token').length && $('#generate-sms-token').data('action')) {
          ModalRegister.sendSmsToken();
        }

      } else {
        if (campaigns === 0) {
          $('#register-modal').modal('show');
          $('#myWizard').easyWizard('goToStep', 3);
          $('#myWizard').easyWizard('resizeSteps');

          // show finish button instead of next button
          $('#button-validate-step').addClass('d-none');
          $('#button-finish-step').removeClass('d-none');
        }
      }
    }
  }

  // Input onChange handler
  $('#input-sms-token').on('input', function () {
    if ($(this).val() && $(this).val().length > 0) {
      $('#validate-phone').prop('disabled', false);
    } else {
      $('#validate-phone').prop('disabled', true);
    }
  })

  // Generate token button
  // Open whatsapp to generate token
  // $('#generate-whatsapp-token').on('click', function (e) {
  //   var numero = '+595994133353';
  //   var mensaje = 'Token';
  //   var url = 'https://wa.me/' + numero + '?text=' + encodeURIComponent(mensaje);
  //   window.open(url, '_blank');

  //   ModalRegister.waitOnButton($('#generate-whatsapp-token'), WAIT_RESEND_PHONE_TOKEN);
  // });
  // Open whatsapp to generate token
  $('#generate-sms-token').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    ModalRegister.sendSmsToken();
  });

  //Validate phone number
  $('#validate-phone').on('click', function (e) {
    let $button = $('#validate-phone');
    const validateUrl = $button.data('action');
    if (!validateUrl || !String(validateUrl).trim()) {
      return;
    }
    $button.button('loading');
      // ModalRegister.waitOnButton($button, WAIT_RESEND_PHONE_TOKEN);
    $.ajax({
      url: validateUrl,
      method: 'post',
      data: {
        code: $('#calling_code_recheck').val(),
        phone: $('#input_phone_recheck').val(),
        token: $('#input-sms-token').val()
      },
      dataType: 'json',
    }).done(function (json) {
      $('#sms-validation-step-section').addClass('d-none');
      $('#validated-phone-message').html(json.message);
      $('#validated-phone-message').removeClass('d-none');
      $('#button-validate-step').removeAttr('disabled');
    }).fail(function (json) {
      swalError(json);
    }).always(function () {
      $button.button('reset');
      // ModalRegister.waitOnButton($button, WAIT_RESEND_PHONE_TOKEN);
    });
  });

  // handle click of second step button
  $('#button-validate-step').on('click', function (e) {
    $('#myWizard').easyWizard('goToStep', 3);

    // show the finish button and hide the next button
    $('#button-validate-step').addClass('d-none');
    $('#button-finish-step').removeClass('d-none');
  });

  $('#promotional-code').on('input', function (e) {
    let $button = $('#claim-bonus');
    if ($(this).val() && $(this).val().length > 0) {
      $button.prop('disabled', false);
    } else {
      $button.prop('disabled', true);
    }
  });

  // Claim bonus code
  $('#claim-bonus').on('click', function (e) {
    e.preventDefault();
    let $button = $(this);
    const claimUrl = $button.data('action');
    if (!claimUrl || !String(claimUrl).trim()) {
      return;
    }
    $button.button('loading');
    $.ajax({
      url: claimUrl,
      method: 'post',
      data: {
        bonus_code: $('#promotional-code').val()
      },
      dataType: 'json',
    }).done(function (json) {
      $('#claim-bonus').prop('disabled', true);
      $('#promotional-code').prop('disabled', true);

      // if (json?.data?.extraData?.campaign?.data?.allocation_criteria.includes(1) || json?.data?.extraData?.campaign?.data?.allocation_criteria.includes("1")) {
        Swal.fire({
          title: $button.data('success-title'),
          html: $button.data('success-message'),
          icon: 'warning',
          iconHtml: "<img src='" + $button.data('img-url') + "' alt='Bono' style='width: 100px; height: 100px;'>",
          showCancelButton: false,
          confirmButtonColor: '#ff7600',
          // cancelButtonColor: '#999',
          confirmButtonText: $button.data('success-button-text'),
          // cancelButtonText: i18next.t('cancel')
        }).then((result) => {
          // if (result.value) {
            $('#register-modal').modal('hide');
            sessionStorage.setItem('modalRegister', 'shown');
            window.location.href = $button.data('action-redirect');
          // }
        });
      // } else {
      //   Swal.fire({
      //     title: i18next.t('bonus_code'),
      //     html: json.data.message,
      //     icon: 'info',
      //     confirmButtonColor: '#ff7600',
      //     confirmButtonText: i18next.t('Ok')
      //   }).then((result) => {
      //     $('#register-modal').modal('hide');
      //     sessionStorage.setItem('modalRegister', 'shown');
      //     if (result.value) {
      //       window.location.href = json.data.route;
      //     }
      //   });
      // }
    }).fail(function (json) {
      swalError(json);
    }).always(function () {
      $button.button('reset');
    });
  });


  $('#button-finish-step').on('click', function (e) {
    Swal.fire({
          title: i18next.t('confirm'),
          html: "Registro completado con éxito",
          icon: 'info',
          showCancelButton: false,
          confirmButtonColor: '#ff7600',
          // cancelButtonColor: '#999',
          confirmButtonText: i18next.t('Ok'),
          // cancelButtonText: i18next.t('cancel')
        }).then((result) => {
          if (result.value) {
            $('#register-modal').modal('hide');
            sessionStorage.setItem('modalRegister', 'shown');
          }
        });
  });
});
